<template>
  <div>
    <!-- document name pop up -->
    <doc-name v-if="settingTitle" ></doc-name>
    <doc-clone-name v-if="settingCloneTitle"></doc-clone-name>
    <component v-bind:is="app_name" v-bind:docData="documentData" v-else>
      <!-- component changes when vm.currentView changes! -->
    </component>
    <DocumentContent v-if="documentData.document_id" />
  </div>
</template>

<script>
import Dax from "./Dax";
import ColourFan from "./colour-generator/ColourFan";
import ColourImage from "./colour-generator/ColourImage";
import ColourPalette from "./colour-generator/ColourPalette";
import DocumentHttpService from "../services/DocumentHttpService";
import DocName from "./DocName";
import DocCloneName from "./DocCloneName";
import ApiService from "../api/api.service";
import { mapGetters } from "vuex";
import Login from "../views/Login";
import DocumentContent from "./DocumentContent";
import MCode from "./MCode";
import RAWCode from "./RAWCode";
import Notepad from "./Notepad";
import PythonCode from "./PythonCode";
import RCode from "./RCode";
import PowerBITheme from "./PowerBi.vue";

export default {
  name: "Document",
  props: ["document_id"],
  components: {
    PythonCode,
    RCode,
    Notepad,
    DocName,
    DocCloneName,
    Dax,
    ColourFan,
    ColourImage,
    ColourPalette,
    Login,
    DocumentContent,
    MCode,
    RAWCode,
    PowerBITheme,
  },
  data: function () {
    return {
      app_name: "",
      docService: null,
      title: null,
      documentData: {
        name: "",
        description: "",
        shared: false,
        entity_name: this.app_name,
        entity_data: {},
      },
      settingTitle: false,
      settingCloneTitle: false,
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      getUser: "getUser",
    }),
  },
  mounted() {
    if (!this.app_name) {
      if (this.$route.name === "Colours Fan") {
        this.app_name = "ColourFan";
      } else if (this.$route.name === "Image to Colours") {
        this.app_name = "ColourImage";
      } else if (this.$route.name === "Colours Palette") {
        this.app_name = "ColourPalette";
      } else if (this.$route.name === "Dax") {
        this.app_name = "Dax";
      } else if (this.$route.name === "M Code") {
        this.app_name = "MCode";
      } else if (this.$route.name === "RAW Code") {
        this.app_name = "RAWCode";
      } else if (this.$route.name === "PythonCode") {
        this.app_name = "PythonCode";
      } else if (this.$route.name === "RCode") {
        this.app_name = "RCode";
      } else if (this.$route.name === "Notepad") {
        this.app_name = "Notepad";
      } else if (this.$route.name === "Power Bi Theme") {
        this.app_name = "PowerBITheme";
      }
    }
    const titleEl = document.querySelector("head title");
    titleEl.textContent = this.$route.name + " - Analyst Hub by Enterprise DNA";

    // onload check for saved document id
    this.docService = new DocumentHttpService();
  },
  methods: {
    saveDoc(docInfo = null, entityData, redirect = true) {
      this.documentData.entity_name = this.app_name;

      if (entityData) {
        this.documentData.entity_data = entityData;
      }

      // store locally when user logging while user registers etc.
      if (!this.isLoggedIn) {
        localStorage.setItem(
          "temp_app_data",
          JSON.stringify(this.documentData)
        );
        this.$router.push({ path: "/login" });
      }

      // setting title and description
      if (!docInfo && !this.documentData.name) {
        this.setDocumentTitle();
        return;
      } else if (docInfo && docInfo.name) {
        this.documentData.name = docInfo.name;
        this.documentData.description = docInfo.description;
        this.documentData.shared = docInfo.shared;
        this.documentData.team_shared = docInfo.team_shared;
      }

      this.docService.store(this.documentData).then(
        (res) => {
          this.documentData = res.data.doc;
          this.documentData.entity_data = res.data.entity;

          this.updateUserData();
          // set url path
          if (redirect) {
            setTimeout(() => {
              this.$router.push({
                path: this.$route.path + "?id=" + res.data.doc.document_id,
              });
              this.settingTitle = false;
              // window.location.replace(this.$route.path +'?id=' + res.data.doc.document_id);
            }, 2000);
          }
        },
        function (res) {
          console.error(res);
        }
      );

      // this.$router.push();
    },

    updateDoc(docId, entityData) {
      if (entityData) {
        this.documentData.entity_data = entityData;
      }
      ApiService.setHeader();
      ApiService.put("/api/document/" + docId, this.documentData);
    },

    loadDoc(id) {
      return this.docService.get(id).then(
        (res) => {
          if (!res.data.doc) {
            // redirect to new page
            this.$router.push(this.$route.path);
            this.$router.go(this.$router.currentRoute);
          }
          const titleEl = document.querySelector("head title");
          titleEl.textContent =
            res.data.doc.name + " - Analyst Hub by Enterprise DNA";

          if (res.data.doc.latest_three === false) {
            this.$router.push({ name: "Documents Limit" });
          }
          this.documentData = res.data.doc;
          this.documentData.entity_data = res.data.entity;
          return res;
        },
        function (res) {
          console.error(res);
        }
      );
    },
    update() {},
    delete() {},

    setDocumentTitle: function () {
      this.settingTitle = true;
    },

    checkIfIamAuthor() {
      let user = JSON.parse(localStorage.getItem("user"));
      if (user && user.id && this.documentData.user_id) {
        return user.id === this.documentData.user_id;
      }

      return false;
    },

    updateUserData() {
      // updated documents count etc.
      ApiService.setHeader();
      ApiService.get("/api/user")
        .then(({ data }) => {
          window.localStorage.setItem("user", JSON.stringify(data));
        })
        .catch((error) => {
          throw new Error("failed to load user");
        });
    },
  },
};
</script>

<style scoped>
</style>
